import { FrontendVersionRoomYDoc } from "../version-room/frontend";
import { z } from "zod";
// We store pages and groups in the same way they are stored in the database.
// This means that instead of groups having childrenIds array, all items have
// parentPersistentId property that points to the parent item in the tree.
// Upon read this gets converted to the format that client expects, which is
// ordered childrenIds array on all groups.
//
// The decision behind it is that we potentially want to get rid of childrenIds
// array entirely because it makes group updates more complicated. For now
// resolving it on fly is a tradeoff for not rewriting client to stop relying
// on children ids array.
//
// Types
//
export const DocumentationHierarchySettings = z.object({
    routingVersion: z.string(),
    isDraftFeatureAdopted: z.boolean(),
    isApprovalFeatureEnabled: z.boolean(),
    approvalRequiredForPublishing: z.boolean(),
});
/**
 * @deprecated - Use FrontendVersionRoomYDoc.getDocumentationHierarchy
 */
export function yjsToDocumentationHierarchy(doc) {
    return new FrontendVersionRoomYDoc(doc).getDocumentationHierarchy();
}
